import './index.css';
import useTheme from '../../utilities/hooks/theme';
import View from '../view';
import React from 'react';

interface ListFooterComponentProps {
  dataLength?: number;
  loadingMore?: boolean;
  listEnded?: boolean;
  showLinerAfterLimit?: boolean;
}
const ListFooterComponent = ({
  dataLength = 0,
  loadingMore,
  listEnded,
  showLinerAfterLimit = false
}: ListFooterComponentProps) => {
  const { FantasyTheme: theme } = useTheme();
  if (dataLength === 0) return <View />;
  const showLiner = listEnded && (!showLinerAfterLimit || (showLinerAfterLimit && dataLength > 8));
  const liner = {
    backgroundColor: theme.matchListEndLiner
  };
  return (
    <View style={{ alignItems: 'center' }}>
      {loadingMore && <View className="list-footer-loader" />}
      {showLiner && <View className="list-footer-liner" style={liner} />}
    </View>
  );
};

ListFooterComponent.defaultProps = {
  dataLength: 0
};
export default React.memo(ListFooterComponent);
